import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";
import "../styles/AdminEMIRequestDetail.css";

function AdminEMIRequestDetail() {
  const { emi_id } = useParams();
  const [data, setData] = useState(null);

  const canView = hasPermission("emi", "view");
  const canEdit = hasPermission("emi", "edit");

  useEffect(() => {
    if (!canView) return;

    const loadEMI = async () => {
      try {
        const res = await fetch(
          `https://kolibusiness.com/backend/get-emi-request-detail.php?emi_id=${emi_id}`
        );

        const text = await res.text();
        let parsed;

        try {
          parsed = JSON.parse(text);
        } catch (err) {
          console.error("❌ Invalid JSON:", text);
          alert("Server error:\n" + text);
          return;
        }

        if (parsed.error) {
          alert("Error: " + parsed.error);
          return;
        }

        setData(parsed);
      } catch (err) {
        console.error("Fetch error:", err);
        alert("Failed to load EMI details.");
      }
    };

    loadEMI();
  }, [emi_id, canView]);

  if (!canView) {
    return (
      <AdminLayout>
        <p className="loading error">❌ You do not have permission to view this page.</p>
      </AdminLayout>
    );
  }

  if (!data) {
    return (
      <AdminLayout>
        <p className="loading">Loading EMI Details...</p>
      </AdminLayout>
    );
  }

  const renderImage = (label, src) => (
    <div className="doc-card">
      <p className="doc-label">{label}</p>
      {src ? (
        <>
          <a href={src} target="_blank" rel="noopener noreferrer">
            <img
              src={src}
              alt={label}
              className="doc-image"
              onError={(e) => {
                e.target.src = "/no-image.png";
                e.target.style.border = "2px dashed red";
              }}
            />
          </a>
          {canEdit && (
            <a
              href={src}
              className="doc-download"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              ⬇ Download
            </a>
          )}
        </>
      ) : (
        <p className="not-uploaded">Not uploaded</p>
      )}
    </div>
  );

  return (
    <AdminLayout>
      <div className="emi-detail-container">
        <div className="emi-header">
          <h2>📋 EMI Request Detail</h2>
          {canEdit && (
            <button onClick={() => window.print()} className="pdf-btn">
              📄 Export PDF
            </button>
          )}
        </div>

        <div className="emi-section">
          <h3>👤 Customer Info</h3>
          <div className="info-grid">
            <p><b>Name:</b> {data.name}</p>
            <p><b>Mobile:</b> {data.phone}</p>
            <p><b>Email:</b> {data.email}</p>
            <p><b>Aadhar No:</b> {data.aadhaar}</p>
            <p><b>PAN No:</b> {data.pan}</p>
            <p><b>Account No:</b> {data.account_no}</p>
            <p><b>IFSC:</b> {data.ifsc}</p>
            <p><b>Bank:</b> {data.bank_name}</p>
            <p><b>Account Type:</b> {data.account_type}</p>
            <p><b>Amount:</b> ₹{data.amount}</p>
            <p><b>Status:</b> {data.status || "Pending"}</p>
          </div>
        </div>

        <div className="emi-section">
          <h3>📎 Uploaded Documents</h3>
          <div className="doc-grid">
            {renderImage("Aadhaar Front", data.aadhaar_front)}
            {renderImage("Aadhaar Back", data.aadhaar_back)}
            {renderImage("PAN Card", data.pan_card)}
            {renderImage("Passbook", data.passbook)}
            {renderImage("Cheque", data.cheque)}
            {renderImage("Selfie Photo", data.photo)}
            {renderImage("Debit Card Front", data.debit_front)}
            {renderImage("Debit Card Back", data.debit_back)}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminEMIRequestDetail;
